





























import VueOptions from '@utils/VueOptions'
import Modal from '@/components/Modal'
import FormFieldRadioButton from '@ui/FormBuilder/FormFields/FormFieldRadioButton'
import RequestButton from '@/components/RequestButton'
import VoidOfferTrigger from './VoidOfferTrigger.coffee'

settings =
  name: 'VoidOfferTriggerModal'

  vue:
    props: ['resourceComponent', 'resourceKey']
    mixins: [VoidOfferTrigger.trigger()]

    components: {
      Modal,
      FormFieldRadioButton,
      RequestButton,
    }

    computed:
      modalConfig: -> @modal.config || {}

      optionsForVoidedBy: ->
        [
          { label: 'Voided by Organizer', value: 'organizer' }
          { label: 'Voided by Sponsor', value: 'sponsor' }
        ]

export default VueOptions.vue settings
